const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b7b9ee3e-05ae-4919-9af6-94d472789a93",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.92,5.9H5a.55.55,0,0,0,.55-.55A.54.54,0,0,0,5,4.8H3.92a.55.55,0,0,0-.55.55A.55.55,0,0,0,3.92,5.9Z",
    style: {
      fill: "#456d86"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33,9.21H3.92a.55.55,0,0,0-.55.55.55.55,0,0,0,.55.55H8.33a.55.55,0,0,0,.55-.55A.55.55,0,0,0,8.33,9.21Z",
    style: {
      fill: "#456d86"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33,7H3.92a.55.55,0,1,0,0,1.1H8.33a.55.55,0,1,0,0-1.1Z",
    style: {
      fill: "#456d86"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,4.58a.66.66,0,0,0-.12-.17L7.62,1.1A.57.57,0,0,0,7.44,1a.52.52,0,0,0-.21,0H2.82A1.65,1.65,0,0,0,1.17,2.59v8.82a1.65,1.65,0,0,0,1.65,1.65H9.43a1.65,1.65,0,0,0,1.65-1.65V4.79A.52.52,0,0,0,11,4.58ZM7.78,2.81,9.21,4.25H7.78ZM9.43,12H2.82a.55.55,0,0,1-.55-.55V2.59A.54.54,0,0,1,2.82,2H6.68V4.79a.54.54,0,0,0,.55.55H10v6.07A.56.56,0,0,1,9.43,12Z",
    style: {
      fill: "#456d86"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file_text.3002d33a5563dcbe495a818d00b7ef75.svg";
export { ForwardRef as ReactComponent };